export interface LoginForm {
  username: string,
  passwd: string
}

export interface User {
  adid: number,
  blocked: false,
  cardid: string,
  driverid: string,
  email: string,
  entunits: string,
  fio: string,
  id: number,
  lastauth: number,
  name: string,
  organization: string,
  password: string,
  roleid: number,
  tabn: string,
  token: string,
  tokenexpired: number
}

export interface DictFilter {
  field: string,
  condition: string,
  operator: string,
  combine?: string
}

export interface DictOptions {
  page: number,
  itemsPerPage: number,
  groupBy?: Array<string>,
  groupDesc?: Array<boolean>,
  multiSort?: boolean,
  mustSort?: boolean,
  sortBy?: Array<string>,
  sortDesc?: Array<boolean>
}

export interface OrderOption {
  table: string,
  field: string,
  sourcefield: string
}

export interface DictRequest {
  filter: Array<DictFilter>,
  options: DictOptions,
  orderoption: OrderOption,
  entunits: Array<string>,
  spp: string,
  signFilter: Array<{ roleid: number, ftype: number }>
}

export interface DictParam {
  idx: number,
  noLists?: boolean,
  request: DictRequest
}

export interface DicListItem {
  text: string,
  value: string | number
}

export class DictList extends Array<DicListItem> { }

export class DictDataItem {
  constructor (name: string) {
    this.name = name
    this.humanName = ''
    this.isShowForm = false
    this.defaultRow = {}
    this.currentRow = {}
    this.rows = []
    this.rowsCount = 0
    this.headers = []
    this.fields = {}
    this.signedFields = ''
    this.locked = {
      fields: '',
      add: true,
      read: true,
      upd: true,
      del: true
    }
  }

  name: string
  humanName: string
  isShowForm: boolean
  defaultRow: any
  currentRow: any
  rows: Array<any>
  rowsCount: number
  headers: any
  formfields: any
  EPLfields: any
  fields: any
  signedFields: string
  locked: {
    fields: string,
    add: boolean,
    read: boolean,
    upd: boolean,
    del: boolean
  }
}

export type VForm = Vue & {
  validate: () => boolean,
  resetValidation: () => void
}

interface CertificateItem { isValid: boolean, serial: string, name: string, fromdate: object, todate: object, thumbprint: string }

export class Certificates extends Array<CertificateItem> { }
